/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.chevron-left\":\"Leftward arrow\"}");